<nz-transfer
  class="custom-transfer"
  [nzDataSource]="list"
  [nzTitles]="titles"
  [nzDisabled]="disabled"
  nzShowSearch
  [nzFilterOption]="filterOption"
></nz-transfer>
